import { calculateFreelanceRate } from '../freelanceRateCalculator.js';

function formatCurrency(val) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);
}

function calculate() {
    const input = {
        desiredIncome: parseFloat(document.getElementById('desiredIncome').value) || 0,
        businessExpenses: parseFloat(document.getElementById('businessExpenses').value) || 0,
        taxRate: parseFloat(document.getElementById('taxRate').value) || 0,
        billableHoursPerWeek: parseFloat(document.getElementById('billableHours').value) || 0,
        weeksPerYear: parseFloat(document.getElementById('weeks').value) || 48
    };

    const result = calculateFreelanceRate(input);

    if (!result) {
        document.getElementById('results').innerHTML = '<p style="color: #dc2626;">Please enter valid income and billable hours.</p>';
        return;
    }

    document.getElementById('results').innerHTML = `
        <div class="result-card">
            <p style="margin: 0; font-size: 0.875rem; text-transform: uppercase; font-weight: 600; color: #4f46e5; letter-spacing: 0.05em;">Minimum Billable Rate</p>
            <h2 class="result-total">$${result.hourlyRate}/hr</h2>
            <p class="result-sub">Charge this rate or higher to meet your income goal.</p>
        </div>

        <table class="results-table">
            <tr><th>Breakdown</th><th>Amount</th></tr>
            <tr><td>Desired Net Income</td><td>${formatCurrency(input.desiredIncome)}</td></tr>
            <tr><td>Business Expenses</td><td>${formatCurrency(input.businessExpenses)}</td></tr>
            <tr><td>Estimated Taxes Paid (${input.taxRate}%)</td><td>${formatCurrency(result.taxesPaid)}</td></tr>
            <tr style="border-bottom: 2px solid #1f2937;"><td><strong>Gross Income Needed</strong></td><td><strong>${formatCurrency(result.grossIncome)}</strong></td></tr>
            <tr><td>Annual Billable Hours</td><td>${result.totalBillableHours} hrs</td></tr>
        </table>
        <p style="font-size: 0.75rem; color: #6b7280; margin-top: 1rem;">
            Note: This assumes ${input.billableHoursPerWeek} hours/week for ${input.weeksPerYear} weeks. Remember that unbillable time (admin, marketing) is not covered by this rate; ensure your billable hours are realistic.
        </p>
    `;
}

document.getElementById('calculateBtn').addEventListener('click', calculate);
// Initial load
calculate();
